import { DescriptionPage_ProductVariant as DescriptionPageProductVariant } from '__generated__/graphql-types';

import PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';

import _t from 'i18n!nls/xdp';

export const getKeyInformationModuleTitleForProfessionalCert = (numberOfCourses?: number | null) => {
  if (!numberOfCourses) {
    return _t('Professional Certificate');
  }

  return _t('Professional Certificate - #{numCourses} course series', {
    numCourses: numberOfCourses,
  });
};

export const getKeyInformationModuleTitleForSpecialization = (numberOfCourses?: number | null) => {
  if (!numberOfCourses) {
    return _t('Specialization');
  }

  return _t('Specialization - #{numCourses} course series', {
    numCourses: numberOfCourses,
  });
};

export const getKeyInformationModuleTitle = (
  numberOfCourses: number,
  productVariant: DescriptionPageProductVariant
) => {
  if (!numberOfCourses) {
    return productVariant === DescriptionPageProductVariant.StandardSpecialization
      ? _t('Specialization')
      : _t('Professional Certificate');
  }

  return productVariant === DescriptionPageProductVariant.StandardSpecialization
    ? _t('Specialization - #{numCourses} course series', {
        numCourses: numberOfCourses,
      })
    : _t('Professional Certificate - #{numCourses} course series', {
        numCourses: numberOfCourses,
      });
};

export const getKeyInformationModuleSubtitle = (productVariant: DescriptionPageProductVariant) => {
  return productVariant === DescriptionPageProductVariant.StandardSpecialization
    ? _t('Get in-depth knowledge of a subject')
    : _t('Earn a career credential that demonstrates your expertise');
};

export const getKeyInformationModuleSubtitleForProject = (pageType?: typeof PAGE_TYPES[keyof typeof PAGE_TYPES]) => {
  if (pageType === PAGE_TYPES.GUIDED_PROJECT) {
    return _t('Learn, practice, and apply job-ready skills with expert guidance');
  } else if (pageType === PAGE_TYPES.PORTFOLIO_PROJECT) {
    return _t('Demonstrate your skills to employers, and leverage industry tools to solve real-world challenges');
  } else {
    return _t('Build in-demand job skills with step-by-step instructions');
  }
};
